// Dati del negozio — modifica qui per aggiornare i contenuti del sito.
export const shop = {
  name: "La casa del pigiama",
  tagline: "Eleganza e comodità nel cuore di Novara",
  city: "Novara",
  address: "Via XX Settembre, 8, 28100 Novara (NO)",
  phone: "0321 399527",
  phoneHref: "tel:+390321399527",
  province: "Provincia di Novara",
  rating: 4.4,
  reviewsCount: 133,
  mapsQuery: "La casa del pigiama, Via XX Settembre 8, 28100 Novara NO",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=La+casa+del+pigiama+Via+XX+Settembre+8+Novara",
  hours: [
    { day: "Lunedì", time: "09:00 – 13:30 · 15:00 – 19:30" },
    { day: "Martedì", time: "09:00 – 13:30 · 15:00 – 19:30" },
    { day: "Mercoledì", time: "09:00 – 13:30 · 15:00 – 19:30" },
    { day: "Giovedì", time: "09:00 – 13:30 · 15:00 – 19:30" },
    { day: "Venerdì", time: "09:00 – 13:30 · 15:00 – 19:30" },
    { day: "Sabato", time: "09:00 – 13:30 · 15:00 – 19:30" },
    { day: "Domenica", time: "Chiuso" },
  ],
};

export const social = {
  instagram: "https://www.instagram.com/lacasadelpigiama",
  tiktok: "https://www.tiktok.com/@lacasadelpigiama?_r=1&_t=ZN-981tFH3GRFu",
  facebook: "https://www.facebook.com/Lacasadelpigiamanovara",
};

export const images = {
  hero:
    "https://images.unsplash.com/photo-1766056278842-b754f1e093c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwc2lsayUyMHBhamFtYXMlMjBiZWR8ZW58MHx8fHwxNzgyODkwNTc4fDA&ixlib=rb-4.1.0&q=85",
  owner:
    "https://images.unsplash.com/photo-1561527090-a1a24ce97af4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHx3b21hbiUyMGNsb3RoaW5nJTIwc3RvcmUlMjBvd25lciUyMHNtaWxpbmd8ZW58MHx8fHwxNzgyODkwNTc4fDA&ixlib=rb-4.1.0&q=85",
  exterior:
    "https://images.unsplash.com/photo-1721884258144-5d788061e4c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxjbG90aGluZyUyMGJvdXRpcXVlJTIwZXh0ZXJpb3IlMjB2aW50YWdlfGVufDB8fHx8MTc4Mjg5MDU3OHww&ixlib=rb-4.1.0&q=85",
  nightgown:
    "https://images.unsplash.com/photo-1766056278825-55168658f120?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwc2lsayUyMHBhamFtYXMlMjBiZWR8ZW58MHx8fHwxNzgyODkwNTc4fDA&ixlib=rb-4.1.0&q=85",
  pajamas:
    "https://images.unsplash.com/photo-1602584811920-734d01ca3d21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxmb2xkZWQlMjBwYWphbWFzJTIwc29mdCUyMGNvdHRvbnxlbnwwfHx8fDE3ODI4OTA2NDl8MA&ixlib=rb-4.1.0&q=85",
  robe:
    "https://images.unsplash.com/photo-1770294759101-fae1377d4d34?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxjb3p5JTIwcm9iZSUyMGxvdW5nZXdlYXIlMjB3b21hbnxlbnwwfHx8fDE3ODI4OTA2NDl8MA&ixlib=rb-4.1.0&q=85",
  loungewear:
    "https://images.unsplash.com/photo-1591349215290-8e909a4577d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxjb3p5JTIwcm9iZSUyMGxvdW5nZXdlYXIlMjB3b21hbnxlbnwwfHx8fDE3ODI4OTA2NDl8MA&ixlib=rb-4.1.0&q=85",
  interior:
    "https://images.unsplash.com/photo-1766934587214-86e21b3ae093?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxib3V0aXF1ZSUyMGNsb3RoaW5nJTIwc3RvcmUlMjBpbnRlcmlvciUyMHdhcm18ZW58MHx8fHwxNzgyODkwNjQ5fDA&ixlib=rb-4.1.0&q=85",
  store1: "/store/s1.jpg",
  store2: "/store/s2.jpg",
  store3: "/store/s3.jpg",
  facciata: "/store/facciata.jpg",
  catDonna: "/cat/donna.jpg",
  catUomo: "/cat/uomo.jpg",
  catBimbi: "/cat/bimbi.jpg",
  catTerza: "/cat/terza-eta.jpg",
};

export const categories = [
  {
    title: "Donna",
    slug: "donna",
    desc: "Pigiami, camicie da notte e vestaglie: eleganza e comodità per lei, in ogni stagione.",
    img: images.catDonna,
    span: "md:col-span-8",
    tall: false,
  },
  {
    title: "Uomo",
    slug: "uomo",
    desc: "Pigiami, homewear e intimo maschile. Tessuti caldi e classici che durano nel tempo.",
    img: images.catUomo,
    span: "md:col-span-4",
    tall: false,
  },
  {
    title: "Bimbi",
    slug: "bimbi",
    desc: "Pigiamini morbidi e fantasie allegre per i più piccoli, dai neonati ai ragazzi.",
    img: images.catBimbi,
    span: "md:col-span-4",
    tall: false,
  },
  {
    title: "Terza Età",
    slug: "terza-eta",
    desc: "Camicie da notte e pigiami classici, comodi e facili da indossare. Anche taglie comode.",
    img: images.catTerza,
    span: "md:col-span-4",
    tall: false,
  },
  {
    title: "Intimo",
    slug: "intimo",
    desc: "Un ampio reparto di intimo e calzetteria per tutta la famiglia, per ogni esigenza.",
    img: images.loungewear,
    span: "md:col-span-4",
    tall: false,
  },
];

export const strengths = [
  "Prezzi Bassi",
  "Ampia Scelta",
  "Taglie Comode",
  "Consulenza Personalizzata",
  "Qualità che Dura",
  "Un Negozio Storico",
];

export const reviews = [
  {
    name: "Laura Maroni",
    stars: 5,
    text: "È un negozio dove si risparmia sempre e mi trovo benissimo da anni. La signora è magnifica, gentile, sa consigliare e non si risparmia mai. C'è tantissima scelta!",
  },
  {
    name: "Vincenzo Platini",
    stars: 5,
    text: "Su suggerimento di un amico mi sono recato in questo negozio specializzato in pigiami. La scelta è vastissima, anche per taglie larghe: ho trovato proprio quello che cercavo.",
  },
  {
    name: "Nicola Agostinetto",
    stars: 4,
    text: "Ottima scelta e buon rapporto qualità/prezzo. La titolare è molto gentile. Consiglio una visita anche per i regali di Natale, l'esterno del negozio è da fotografare.",
  },
  {
    name: "Stefano Cavallero",
    stars: 4,
    text: "Storico negozio specializzato nella vendita di pigiami e camicie da notte per tutte le età e per tutte le tasche. Ampia scelta.",
  },
  {
    name: "Giulia Gruniuk",
    stars: 5,
    text: "Negozio piccolo ma trovo prezzi bassi.",
  },
  {
    name: "Silvana Guida",
    stars: 4,
    text: "Buona scelta di pigiami, camicie da notte, vestaglie e altro abbigliamento intimo.",
  },
];
